/**
 * @generated SignedSource<<89702015f6b3554c97942ca263d5ce69>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedTrackingFunctions_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly searchResultData: {
    readonly bm25ResultCount: number | null;
  } | null;
  readonly sponsored: {
    readonly maxAvailable: number | null;
  } | null;
  readonly totalResults: number | null;
  readonly trackedAbTests: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "SbSharedTrackingFunctions_itemSearch";
};
export type SbSharedTrackingFunctions_itemSearch$key = {
  readonly " $data"?: SbSharedTrackingFunctions_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedTrackingFunctions_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "SbSharedTrackingFunctions_itemSearch"
};

(node as any).hash = "9f0aa941d184dd02b51cec2ea357943d";

export default node;
